module.exports = __webpack_public_path__ + "img/shopping.a9258483.png";